import React from 'react';
import { observer } from 'mobx-react';
import {
	IButtonStyles,
	IconButton,
	Panel,
	PanelType,
	Stack,
	Text,
	getTheme,
} from '@fluentui/react';
import { FiltersState } from '../../state/FiltersState';
import FilterOptions from './FilterOptions';

interface IFilterPanelProps {
	state: FiltersState;
}

class FiltersPanel extends React.Component<IFilterPanelProps> {
	render() {
		return (
			<Panel
				isLightDismiss={true}
				isOpen={this.props.state.show}
				onDismiss={() => this.props.state.toggleFilterPanel(false)}
				onRenderNavigation={this._renderCustomNavigation}
				type={PanelType.smallFixedFar}
				closeButtonAriaLabel="Close"
			>
				<Stack>{this._getPanelContent()}</Stack>
			</Panel>
		);
	}

	private _renderCustomNavigation = (props?: any): JSX.Element => {
		const theme = getTheme();
		const iconButtonStyles: Partial<IButtonStyles> = {
			root: {
				color: theme.palette.neutralPrimary,
				marginLeft: 'auto',
				marginTop: '2px',
				marginRight: '2px',
			},
			rootHovered: {
				color: theme.palette.neutralDark,
			},
		};

		return (
			<Stack
				horizontal
				verticalAlign="center"
				horizontalAlign="space-between"
				tokens={{ padding: '8px 24px', childrenGap: 8 }}
				styles={{ root: { borderBottom: 'none' } }}
			>
				<Text variant="xLarge">Filters</Text>
				<Stack horizontal>
					<IconButton
						id="clearFilters"
						styles={iconButtonStyles}
						iconProps={{ iconName: 'ClearFilter' }}
						ariaLabel="Clear all filters"
						onClick={() => this.props.state.clearFilters()}
					/>
					<IconButton
						styles={iconButtonStyles}
						iconProps={{ iconName: 'Cancel' }}
						ariaLabel="Close"
						onClick={() => this.props.state.toggleFilterPanel(false)}
					/>
				</Stack>
			</Stack>
		);
	};

	private _getPanelContent(): React.ReactNode {
		if (this.props.state.filterFields.length === 0) {
			return <Text>No custom fields configured for this project.</Text>;
		}

		let filterOptions = this.props.state.filterFields.map(
			(filterOptionState, index) => {
				return (
					<FilterOptions
						filters={this.props.state}
						key={index}
						state={filterOptionState}
					/>
				);
			},
		);

		return filterOptions.map((fo, i) => (
			<div key={'filteroption-' + i} style={{ marginBottom: 10 }}>
				{fo}
			</div>
		));
	}
}

export default observer(FiltersPanel);
